import "./style.scss";
import React, { useEffect, useMemo, useRef, useState } from "react";
import GaugeChart from "../../shared/chartjs/GaugeChart";
import Spacer from "../../shared/components/Spacer";
import PieChart from "../../shared/chartjs/PieChart";
import { Box, Paper, Popper, Typography } from "@material-ui/core";
import i18n from "../../localization/i18n";
import { connect, useDispatch } from "react-redux";
import { GaugeChartDummyData, PieChartDummyData } from "../../shared/chartjs/dummyData/MultipledummyData";
import {
  GetDashboardGraphCalculation,
  GetLatestRoadSurveyedFile,
  GetYearsSlider,
  SelectUserFilter,
  SetYearSelected,
} from "../../services/actions/RoadAction";
import { globalHandleMenuOnClick } from "../../shared/navMenu";
import { resetDataType } from "../../services/actions/GisAction";
import { GetUsers } from "../../services/actions/UserAction";
import { compose, lifecycle } from "recompose";
import { setGraphData } from "../../shared/chartjs/CustomGraphModule";
import Loading from "../../shared/components/Loading";
const DataDashBoard = ({
  loading,
  userFilter,
  GetYearsSliderData,
  SetYearFilter,
  surfaces,
}) => {
  const dispatch = useDispatch();
  const [isDummy, setDummyFlg] = useState(false);
  const [gaugeChartData, setGaugeChartData] = useState({});
  const [pieChartData, setPieChartData] = useState({});
  const [year, setYear] = useState(null);
  const scrollContainer1Ref = useRef(null);
  const scrollContainer2Ref = useRef(null);
  const scrollContainer3Ref = useRef(null);
  const [mousePosition, setMousePosition] = useState(null);
  
  const handleScroll = () => {
    if (scrollContainer1Ref.current) {
      scrollContainer1Ref.current.scrollLeft =
        scrollContainer3Ref.current.scrollLeft;
    }
    if (scrollContainer2Ref.current) {
      scrollContainer2Ref.current.scrollLeft =
        scrollContainer3Ref.current.scrollLeft;
    }
  };
  const handleMouseMove = (e, year) => {
    setYear(year);
    setMousePosition({
      top: e.clientY + 10,
      left: e.clientX + 10,
    });
  };
  const handleMouseLeave = () => {
    setMousePosition(null);
  };
  useEffect(() => {
    const el = scrollContainer3Ref.current;
    if (!el) return;
    const scrollToRight = () => {
      el.scrollLeft = el.scrollWidth - el.clientWidth;
      handleScroll();
    };
    scrollToRight();
    const observer = new MutationObserver(() => {
      scrollToRight();
    });
    observer.observe(el, {
      childList: true,
      subtree: true,
    });
    return () => observer.disconnect();
  }, []);

  const getData = async (userFilter, surfaces) => {
    const data = await dispatch(GetLatestRoadSurveyedFile(userFilter));
    if (
      data &&
      data[0] &&
      (data[0].type == "SPM_PASER" || data[0].type == "SPM_PCI")
    ) {
      setGaugeChartData(JSON.parse(JSON.stringify(GaugeChartDummyData)));
      setPieChartData(JSON.parse(JSON.stringify(PieChartDummyData)));
      setDummyFlg(true);
    } else if (data && data[0]) {
      setGraphData({
        dispatch,
        action: GetDashboardGraphCalculation,
        params: { userId: userFilter },
        surfaces,
        setGaugeChartData,
        setPieChartData,
      });
      setDummyFlg(false);
    }
  };

  useEffect(() => {
    if (userFilter != null) {
      GetYearsSliderData();
      getData(userFilter, surfaces);
    }
  }, [userFilter, surfaces]);

  const dummyLabelBoxStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '1000px',
    height: '300px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '200px',
    fontWeight: 'bold',
    color: '#000',
    zIndex: 9999,
    border: 'none',
  };
  return (
    <Box>
      {loading && (
        <div className="loading-container">
          <Loading />
        </div>
      )}
      <Spacer size={10} />
      <Box className="flex-box">
        <Box className="title-item">{i18n.t("average_score")}</Box>
        <Box
          className="attention-item"
          dangerouslySetInnerHTML={{ __html: i18n.t("attention") }}
        ></Box>
      </Box>
      <Box
        className="dashboard-item offset-item"
        ref={scrollContainer1Ref}
        style={{ minHeight: "300px" }}
      >
        {gaugeChartData &&
          Object.keys(gaugeChartData).map((_year) =>
            gaugeChartData[_year] ? (
              <Box
                className="gauge-chart-box"
                key={_year + "_GaugeChart"}
                onClick={() => {
                  if (!isDummy) {
                    SetYearFilter(Number(_year));
                    dispatch(resetDataType());
                    globalHandleMenuOnClick("gis");
                  }
                }}
                onMouseMove={(e) => {
                  if (!isDummy) {
                    handleMouseMove(e, _year);
                  }
                }}
                onMouseLeave={handleMouseLeave}
              >
                <GaugeChart datasets={gaugeChartData[_year]?.datasets} />
              </Box>
            ) : (
              <React.Fragment key={_year + "_GaugeChart"} />
            )
          )}
      </Box>
      <Box
        className="dashboard-item offset-item"
        style={{ overflowX: "auto", overflowY: "hidden" }}
        ref={scrollContainer3Ref}
        onScroll={handleScroll}
      >
        {gaugeChartData &&
          Object.keys(gaugeChartData).map((_year) =>
            gaugeChartData[_year] ? (
              <Box className="year-item" key={_year}>
                {_year}
              </Box>
            ) : (
              <React.Fragment key={_year} />
            )
          )}
      </Box>
      <Spacer size={10} />
      <Box className="flex-box offset-item">
        <Box className="title-item">{i18n.t("rating_distribution")}</Box>
      </Box>
      <Box
        className="dashboard-item offset-item"
        ref={scrollContainer2Ref}
        style={{ minHeight: "230px" }}
      >
        {pieChartData &&
          Object.keys(pieChartData).map((_year) =>
            pieChartData[_year] ? (
              <Box
                className="pie-chart-box"
                key={_year + "_PieChart"}
                onClick={() => {
                  if (!isDummy) {
                    SetYearFilter(Number(_year));
                    dispatch(resetDataType());
                    globalHandleMenuOnClick("gis");
                  }
                }}
                onMouseMove={(e) => {
                  if (!isDummy) {
                    handleMouseMove(e, _year);
                  }
                }}
                onMouseLeave={handleMouseLeave}
              >
                <PieChart
                  labels={pieChartData[_year]?.labels}
                  datasets={pieChartData[_year]?.datasets}
                />
              </Box>
            ) : (
              <React.Fragment key={_year + "_PieChart"} />
            )
          )}
      </Box>
      <Popper
        open={!!mousePosition}
        style={{
          position: "fixed",
          top: mousePosition?.top ?? -500,
          left: mousePosition?.left ?? -500,
          pointerEvents: "none",
          zIndex: 1500,
        }}
      >
        <Paper className="cursor-item">
          <Typography variant="caption">Click to GIS {year ?? ""}</Typography>
        </Paper>
      </Popper>
      {isDummy && (
        <div style={dummyLabelBoxStyle}>Dummy</div>
      )}
    </Box>
  );
};

export default compose(
  connect(
    (state) => ({
      loading: state.road.loading,
      isAdmin: state.auth.isAdmin,
      userFilter: state.road.userFilter,
      users: state.user.users,
      loggedUser: state.auth.user,
      surfaces: state.surface.surfaces,
    }),
    (dispatch) => ({
      GetYearsSliderData: () => dispatch(GetYearsSlider()),
      SetYearFilter: (year) => dispatch(SetYearSelected(year)),
      getUsers: () => dispatch(GetUsers()),
      SetUserId: (userId) => dispatch(SelectUserFilter(userId)),
    })
  ),
  lifecycle({
    componentDidMount() {
      if (this.props.isAdmin && this.props.userFilter == null) {
        this.props.getUsers();
      } else if (this.props.loggedUser && this.props.userFilter == null) {
        this.props.SetUserId(this.props.loggedUser.id);
      }
    },
    componentWillUnmount() {},
  })
)(DataDashBoard);
